<template>
	<transition name="fade">
		<div v-if="visible" class="login-dialog">

			<div class="login_box loginSeries">
				<i class="iconfont icon-guanbi portal-login-iframe-close-icon" @click="portalLoginClose"></i>
				<p class="title" style="margin-bottom: 61px;">找回密码</p>


				<Form ref="ruleForm" :model="data" :rules="rules" class="userinfo registerInfo" v-if="step==1">
					<FormItem prop="loginName">
						<div class="input-content">
							<Input type="number" v-model="data.loginName" placeholder="请填写手机号" autocomplete="off" />
						</div>
					</FormItem>
					<FormItem prop="pictureCode">
						<div class="input-content">
							<Input type="text" v-model="data.pictureCode" placeholder="图片验证码" style="width: 60%;"
								autocomplete="new-password" />
							<img class="picture" alt="图形验证码" :src="uuPicCode">
							<span class="pictureCodeBtn" @click="getPictureCode()">换一张</span>
						</div>
					</FormItem>
					<FormItem prop="code">
						<div class="input-content">
							<Input type="number" v-model="data.code" placeholder="短信验证码" style="width: 60%;" autocomplete="off" />
							<span :class="['getCode',!!cooling?'forbid':'']">
								<i @click="getCaptcha(data.loginName,data.uuid,data.pictureCode)">
									{{ cooling ? "重新发送(" + cooling + ")" : "发送验证码" }}
								</i>
							</span>
						</div>
					</FormItem>
					<FormItem>
						<button type="button" class="loginSeriesBtn buttonFill" @click="confirmPhoneNum">下一步</button>
					</FormItem>
				</Form>

				<Form ref="newPassword" :model="data2" :rules="rules2" class="userinfo registerInfo" v-else>
					<FormItem prop="password">
						<div class="input-content">
							<Input type="password" id="password" v-model="data2.password" placeholder="密码"
								autocomplete="new-password" />
						</div>
					</FormItem>
					<FormItem prop="password2">
						<div class="input-content">
							<Input type="password" id="password2" v-model="data2.password2" placeholder="确认密码"
								autocomplete="new-password" />
						</div>
					</FormItem>

					<FormItem>
						<button type="button" class="loginSeriesBtn buttonFill" @click="confirmNewPassword">确认设置</button>
					</FormItem>
				</Form>


			</div>



		</div>
	</transition>
</template>

<script>
	import publicMethod from '@/views/publicMethod'
	import qs from 'qs'
	import axios from 'axios'

	import {
		mapActions,
		mapMutations
	} from 'vuex'

	import {
		eventBus
	} from '@/components/login/eventBus.js';

	export default {
		name: 'forgetPasswordDialog',
		mixins: [publicMethod],
		data() {
			return {
				visible: false,
				data: {
					type: 2, // 手机2,邮箱1
					loginName: "", // 账号
					pictureCode: "", // 图片验证码
					code: "", // 手机验证码
					uuid: '' //图片验证码uuid
				},
				data2: {
					password: "", // 密码
					password2: "", // 确认密码
				},
				uuPicCode: '',
				cooling: '',
				noteStatus: 200,
				noteMsg: '',
				step: 1 //1：第一步，验证手机号      2：第二步，确认新密码


			}
		},
		props: {
			phone: {
				type: Array,
				default: function() {
					return [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						required: true,
						pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
						message: '手机号格式不正确',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => this.phoneVerify(rule, value, callback),
						trigger: 'blur'
					}]
				}
			},
			imgCode: {
				type: Array,
				default: function() {
					return [{
							required: true,
							message: '图片验证码不能为空',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => this.pictureCdoeVerify(rule, value, callback),
							trigger: 'blur'
						}
					]
				}
			},
			code: {
				type: Array,
				default: function() {
					return [{
						required: true,
						validator: (rule, value, callback) => this.identifyingCode(rule, value, callback), // 使用箭头函数
						trigger: 'blur'
					}]
				}
			},
			passwordRules: {
				type: Array,
				default: () => {
					return [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, {
						required: true,
						pattern: /^[A-Za-z0-9@#$%]{6,16}$/,
						message: '密码格式不正确',
						trigger: 'blur'
					}]
				}
			},
			confirmPassword: {
				type: Array,
				default: function() {
					return [{
							required: true,
							message: '请再次输入密码',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => this.validateConfirmPassword(rule, value, callback), // 使用箭头函数
							trigger: 'blur'
						}
					]
				}
			},



		},
		computed: {
			rules() {
				return {
					loginName: this.phone,
					pictureCode: this.imgCode,
					code: this.code
				}
			},
			rules2() {
				return {
					password: this.passwordRules,
					password2: this.confirmPassword,
				}
			}

		},
		created() {
			// 订阅事件以显示登录对话框
			eventBus.$on('show-forgetPassword-dialog', () => {
				this.show();
			});
			
			eventBus.$on('hide-dialog', () => {
				this.hide();
			});
		},
		mounted() {
			this.getPictureCode()


		},
		methods: {
			show() {
				this.visible = true;
				document.body.style.overflow = 'hidden'
			},
			hide() {
				this.visible = false;
				document.body.style.removeProperty('overflow');
			},
			operation() {
				this.visible = false;
				document.body.style.removeProperty('overflow');

				eventBus.$emit('show-login-dialog');
			},
			getPictureCode() {
				this.$get(this.domain.dataRealization + "dataCustomer/getVerifiCode", "").then((res) => {
					console.log(res)
					if (res.code == 200 && res.content) {
						this.data.uuid = res.content.uuid;
						this.uuPicCode = res.content.image;
					}
				})
			},
			validateConfirmPassword(rule, value, callback) {
				if (value !== this.data2.password) {
					callback(new Error('两次密码输入不一致'));
				} else {
					callback();
				}
			},
			phoneVerify(rule, value, callback) {
				var this_ = this;

				var params = {};
				params.type = this_.data.type;
				params.loginName = this_.data.loginName;
				this_.$post(this.domain.dataRealization + "dataCustomer/checkCustomer", qs.stringify(params)).then((res) => {
					var data = res.data;
					if (data) {
						if (data.code == 101) { //用户名未注册   返回103,已注册101
							callback();
						} else if (data.code == 103) {
							callback(new Error('账号不存在，请注册后使用'));
						}
					};
				});

			},
			pictureCdoeVerify(rule, value, callback) {
				this.$get(this.domain.dataRealization + "dataCustomer/checkVerifiCode", {
					test: this.data.pictureCode,
					uuid: this.data.uuid
				}).then((res) => {
					if (res.code != 200) {
						callback(new Error('图片验证码错误'));
					} else if (res.code == 200) {
						callback();
					}
				})
			},
			identifyingCode(rule, value, callback) {
				this.$post(this.domain.dataRealization + "dataCustomer/checkIdentifyingCode", qs.stringify({
						phoneNoOrMail: this.data.loginName,
						code: this.data.code
					}))
					.then((res) => {
						var data = res.data;
						if (data.code == 104) {
							callback(new Error('验证码输入错误'));
						} else if (data.code == 106) {
							callback(new Error('验证码失效'));
						} else if (data.code == 200) {
							callback();
						}

					});

			},
			confirmPhoneNum() {
				this.$refs.ruleForm.validate((valid) => {
					console.log(valid)
					if (valid) {
						console.log('可以保存')
						console.log(this.data)
						this.step = 2

					}
				})

			},
			confirmNewPassword() {
				var this_ = this

				this.$refs.newPassword.validate((valid) => {
					console.log(valid)
					if (valid) {
						var obj = {
							phoneNoOrMail: this_.data.loginName,
							type: this_.data.type,
							password: this_.data2.password,
							password2: this_.data2.password2
						}
						this_.$post(this.domain.dataRealization + "dataCustomer/resetPassword", qs.stringify(obj))
							.then((res) => {
								var data = res.data;
								if (data.code == 200) {
									this.operation()
									this.step = 1
								}
							})

					}
				})
			}





		}

	}
</script>

<style scoped>
	@import "~@/assets/css/login/mask.less";
</style>